module.exports = __webpack_public_path__ + "static/media/my-avatar.62690c7c.png";